export default "__VITE_ASSET__BMSl43Vv__"